var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMvLandessignet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 116.22047 57.88944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#005e90;}.cls-2{fill:url(#Unbenannter_Verlauf_5);}.cls-3{fill:url(#Unbenannter_Verlauf_62);}.cls-4{fill:url(#Unbenannter_Verlauf_41);}.cls-5{fill:#f2b700;}.cls-6{fill:url(#Unbenannter_Verlauf_32);}.cls-7{fill:url(#Unbenannter_Verlauf_6);}.cls-8{fill:url(#Unbenannter_Verlauf_6-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_5",
    x1: 77.08391,
    y1: 22.21157,
    x2: 113.43772,
    y2: 30.60451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5e9841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4596,
    stopColor: "#679d48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6da14d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5e9841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_62",
    x1: 77.08391,
    y1: 22.21157,
    x2: 113.43772,
    y2: 30.60451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#289b38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36963,
    stopColor: "#319f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3da54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#289b38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_41",
    x1: 94.87943,
    y1: 13.29865,
    x2: 94.87943,
    y2: 24.93903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2676a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00529,
    stopColor: "#2576a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17354,
    stopColor: "#116897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33964,
    stopColor: "#046192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#005e90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_32",
    x1: 90.27939,
    y1: 14.03253,
    x2: 90.27939,
    y2: 0.00081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc6e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19323,
    stopColor: "#58bee5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73219,
    stopColor: "#21a8dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99375,
    stopColor: "#0ca0d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6",
    x1: 113.26653,
    y1: 13.74329,
    x2: 113.26653,
    y2: 13.73981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96c5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21183,
    stopColor: "#7fb9dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51882,
    stopColor: "#64aad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79155,
    stopColor: "#54a1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e9ecf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6-2",
    x1: 112.71431,
    y1: 13.71899,
    x2: 112.71431,
    y2: 13.71558,
    xlinkHref: "#Unbenannter_Verlauf_6"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NEU_Zeichenfl\xE4che 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tut_gut._40",
    "data-name": "tut gut. 40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.75344,52.80545a3.9581,3.9581,0,0,1-2.40381.78858c-1.52832,0-2.90527-.84571-2.90527-3.10694V44.70438H46.76028A13.6736,13.6736,0,0,0,46.9761,43.013l1.5791-.2583.271-1.95459a11.66615,11.66615,0,0,1,1.70362-.481V43.013h3.20752a13.6736,13.6736,0,0,1-.21582,1.69141h-2.9917v5.27246c0,1.27686.6372,1.69434,1.50586,1.69434a3.2961,3.2961,0,0,0,1.93408-.68506A5.89055,5.89055,0,0,1,53.75344,52.80545Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.99856,53.52469a7.80025,7.80025,0,0,1-.7041-2.63086,3.86811,3.86811,0,0,1-3.79737,2.69971c-2.06787,0-3.312-1.333-3.312-3.77393v-6.48a14.32361,14.32361,0,0,1,2.08545-.58886v6.64062c0,1.45117.70947,2.22656,1.83789,2.22656,1.64355,0,3.10742-1.59668,3.10742-3.915v-1.4624c0-1.61963-.03125-2.77685-.05517-3.19824a10.5755,10.5755,0,0,1,2.10058-.06543c.01709.35889.04053,1.48975.04053,3.26367V49.3953a12.13883,12.13883,0,0,0,.46387,3.69482A4.53265,4.53265,0,0,1,63.99856,53.52469Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.62942,52.80545a3.95815,3.95815,0,0,1-2.40381.78858c-1.52832,0-2.90528-.84571-2.90528-3.10694V44.70438H67.63625a13.67169,13.67169,0,0,0,.21582-1.69141l1.5791-.2583.271-1.95459a11.66636,11.66636,0,0,1,1.70361-.481V43.013H74.6133a13.67169,13.67169,0,0,1-.21582,1.69141h-2.9917v5.27246c0,1.27686.63721,1.69434,1.50586,1.69434a3.296,3.296,0,0,0,1.93408-.68506A5.89051,5.89051,0,0,1,74.62942,52.80545Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.55569,51.67264c1.75.33594,2.498,1.188,2.498,2.43164,0,2.06543-2.11426,3.78516-5.418,3.78516-2.62841,0-4.54052-1.05371-4.54052-2.6499,0-1.39454,1.23925-2.30274,2.69287-2.69629a2.03468,2.03468,0,0,1-1.27149-1.814,1.89434,1.89434,0,0,1,.78711-1.51123,3.13428,3.13428,0,0,1-1.8042-2.86865c0-2.22461,2.0708-3.59863,4.50147-3.59863a5.61022,5.61022,0,0,1,1.73144.25781H91.2051a11.4867,11.4867,0,0,1-.2207,1.56445l-1.49756-.41553a3.09669,3.09669,0,0,1,.69336,1.99707c0,2.22071-2.05811,3.58448-4.49512,3.58448a5.97529,5.97529,0,0,1-1.24121-.12451.79386.79386,0,0,0-.13672.44287c0,.4375.3291.86279,1.7417,1.13427l2.50684.48145ZM89.06447,54.49c0-.47314-.3208-.82324-1.57617-1.06445l-1.96875-.37793c-1.35449.2749-2.48925.92041-2.48925,1.71582,0,.80908,1.25048,1.42285,2.89013,1.42285C87.77346,56.18631,89.06447,55.4368,89.06447,54.49Zm-5.563-8.19726A2.0449,2.0449,0,0,0,85.77785,48.157a2.165,2.165,0,0,0,2.40088-1.94629,2.05016,2.05016,0,0,0-2.271-1.87842A2.17934,2.17934,0,0,0,83.50149,46.29276Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.107,53.52469a7.80046,7.80046,0,0,1-.70411-2.63086,3.86809,3.86809,0,0,1-3.79736,2.69971c-2.06787,0-3.312-1.333-3.312-3.77393v-6.48a14.32325,14.32325,0,0,1,2.08545-.58886v6.64062c0,1.45117.70947,2.22656,1.83789,2.22656,1.64355,0,3.10742-1.59668,3.10742-3.915v-1.4624c0-1.61963-.03125-2.77685-.05518-3.19824a10.57563,10.57563,0,0,1,2.10059-.06543c.01709.35889.04053,1.48975.04053,3.26367V49.3953a12.13883,12.13883,0,0,0,.46387,3.69482A4.53265,4.53265,0,0,1,101.107,53.52469Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.73781,52.80545a3.95809,3.95809,0,0,1-2.4038.78858c-1.52832,0-2.90528-.84571-2.90528-3.10694V44.70438h-1.68408a13.67169,13.67169,0,0,0,.21582-1.69141l1.5791-.2583.271-1.95459a11.66636,11.66636,0,0,1,1.70361-.481V43.013h3.20752a13.67169,13.67169,0,0,1-.21582,1.69141h-2.9917v5.27246c0,1.27686.63721,1.69434,1.50586,1.69434a3.29608,3.29608,0,0,0,1.93408-.68506A5.89055,5.89055,0,0,1,111.73781,52.80545Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.79616,52.3787a1.31151,1.31151,0,0,1,1.28466-1.3794,1.129,1.129,0,0,1,1.13965,1.21436A1.31177,1.31177,0,0,1,114.9358,53.594,1.12982,1.12982,0,0,1,113.79616,52.3787Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MV_40",
    "data-name": "MV 40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.86079.186,56.3,31.2433H50.56612L36.00536.186a.09132.09132,0,0,1,.08216-.11994h.90427A13.42714,13.42714,0,0,1,40.578.44591a6.59341,6.59341,0,0,1,3.43214,3.50857c1.51057,2.97876,9.42287,19.602,9.42287,19.602s7.91237-16.6232,9.42294-19.602A6.5933,6.5933,0,0,1,66.28805.44591,13.42772,13.42772,0,0,1,69.87429.06606h.90428A.09135.09135,0,0,1,70.86079.186Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.78247.07069h-.41792a15.44729,15.44729,0,0,0-3.88737.42444c-1.77327.625-3.05629,2.13153-5.26713,6.58515-1.48466,2.99024-5.77485,11.94025-5.777,11.94452-.00213-.00427-4.29232-8.95428-5.777-11.94452C9.44525,2.62666,8.16223,1.12013,6.389.49513A15.44716,15.44716,0,0,0,2.50159.07069H2.08368L0,31.2518H5.92717L7.39906,8.8536,15.75948,26.493h3.34718L27.46708,8.8536,28.939,31.2518h5.92717Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Bildzeichen_40",
    "data-name": "Bildzeichen 40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.9129,20.95462c-5.679.31559-12.82928,2.6454-17.21232,3.37a52.42079,52.42079,0,0,1-7.24636.61441v6.24207h36.85037V21.45885a47.93751,47.93751,0,0,0-8.41788-.61591C103.67309,20.84294,102.34472,20.87528,100.9129,20.95462Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.9129,20.95462c-5.679.31559-12.82928,2.6454-17.21232,3.37a52.42079,52.42079,0,0,1-7.24636.61441v6.24207h36.85037V21.45885a47.93751,47.93751,0,0,0-8.41788-.61591C103.67309,20.84294,102.34472,20.87528,100.9129,20.95462Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.87955,13.29865c-8.53535,0-18.42531.73388-18.42531.73388V24.939a52.41512,52.41512,0,0,0,7.24635-.61445c4.383-.72454,11.53325-3.05438,17.21228-3.37,1.43183-.07935,2.76024-.11169,3.97382-.11169a47.934,47.934,0,0,1,8.41792.616V13.74329S103.72831,13.29865,94.87955,13.29865Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.10456.00061a64.43537,64.43537,0,0,0-2.6283,9.25488,39.51381,39.51381,0,0,0-.687,4.10034c6.72951.11976,12.51539.38746,12.51539.38746V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.47625,9.25549a64.40366,64.40366,0,0,1,2.6283-9.25407L76.45424.00081V14.03253s9.88995-.73389,18.4253-.73389c1.97325,0,3.9783.02283,5.90967.05719A39.51043,39.51043,0,0,1,101.47625,9.25549Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M113.30461,13.74329l-.07617-.00348Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M112.75442,13.719l-.08022-.00341Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvLandessignet);
export default __webpack_public_path__ + "static/media/mv-landessignet.ec790095a0fed98896e6afddfe384389.svg";
export { ForwardRef as ReactComponent };